module.exports = __webpack_public_path__ + "static/media/student coordinator.ccc01bde.svg";